import { LocalStorageKeys } from "../../../enums/localStorageKeys";
import { getItemFromLocalStorage } from "../../../utils/localStorageHelper";

export const isPrimaryCareFeature = (): boolean => {
  const features = getItemFromLocalStorage(LocalStorageKeys.FEATURES);
  return Boolean(features?.includes("primaryCare"));
};
